import { render } from "./Highscore.vue?vue&type=template&id=668eb565"
import script from "./Highscore.vue?vue&type=script&lang=js"
export * from "./Highscore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__